import { DiscountCodeDetails } from '../entity/DiscountCode';

export function calcDiscountPoint(discountCode: DiscountCodeDetails | null, pointTotal: number): number {
  let discountTotalPoint = 0;

  if (discountCode == null) return discountTotalPoint;

  if (discountCode && discountCode.type === 'success') {
    if (discountCode.discountType === 'absolute') {
      discountTotalPoint = discountCode.amount;
    } else if (discountCode.discountType === 'percentage') {
      //小数点以下の割引は切り捨て
      discountTotalPoint = Math.floor(pointTotal * (discountCode.amount / 100));
    }
    discountTotalPoint = pointTotal < discountTotalPoint ? pointTotal : discountTotalPoint;
  }

  return discountTotalPoint;
}
